<template>
  <div class="">
    <Alert v-if="showErrorModal" variant="destructive" class="mb-4">
      <AlertDescription>{{ errorMessage }}</AlertDescription>
    </Alert>
    <Alert v-if="showSuccessModal" class="mb-4">
      <AlertDescription>
        If a matching account was found an email will be sent to {{ email }} to allow you to reset your password.
      </AlertDescription>
    </Alert>
    <form class="space-y-4" @submit.prevent>
      <!-- title -->
      <div class="text-center">
        <h1 class="text-xl font-medium">Forgotten your password?</h1>
        <h1 class="text-sm sm:text-md font-light pt-1 pb-3">
          Enter your email to reset your password
        </h1>
      </div>

      <!-- email input -->
      <Input
        v-model="email"
        id="emailInput"
        placeholder="Email"
        name="email"
        type="email"
      />
      <!-- The action sends a reset link rather than resetting the password here. -->
      <Button
        id="resetButton"
        type="submit"
        :disabled="disabled"
        @click="forgotPassword()"
        class="w-full h-10"
      >
        Send reset password email
      </Button>
    </form>
  </div>
</template>

<script>
import { Input, Button, Alert, AlertDescription } from '@boogi/ui'

export default {
  name: 'SignIn',
  components: {
    Input,
    Button,
    Alert,
    AlertDescription,
  },
  props: {
    backdoorKey: {
      type: String,
    },
  },
  data() {
    return {
      email: '',
      errors: {},
      errorMessage: '',
      loading: false,
      showErrorModal: false,
      showSuccessModal: false,
    }
  },
  methods: {
    async forgotPassword() {
      this.showErrorModal = false
      this.loading = true
      try {
        const body = { email: this.email }
        const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL

        const response = await this.$apiFetch(`${apiUrl}/private/api/client/auth/forgot-password`, {
          method: 'POST',
          body: JSON.stringify(body),
          headers: { 'Content-Type': 'application/json' },
        })

        // The endpoint is intentionally non-revealing: it returns the same result
        // whether or not the account exists. Show the neutral confirmation on any
        // completed response so the page never silently does nothing, and only
        // surface an error if the request itself failed to reach the server.
        if (response) {
          this.showSuccessModal = true
        } else {
          this.showErrorModal = true
          this.errorMessage = 'Something went wrong. Please try again.'
        }
      } catch (error) {
        this.showErrorModal = true
        this.errorMessage = 'Something went wrong. Please try again.'
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    disabled: function () {
      if (this.email.length == 0) return true
      if (!this.email.includes('@')) return true
      return false
    },
  },
  mounted() {
    document.title = 'Forgot password'
  },
  watch: {},
}
</script>

<style></style>
